import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6970d293"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "change-content-wrap" }
const _hoisted_2 = { class: "form-container" }
const _hoisted_3 = { class: "van-hairline--bottom" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "被保人类型", -1))
const _hoisted_5 = { class: "radio-wrap" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, "* 被保人与投保发票信息保持一致，如有公司发票需求请按企业投保。", -1))
const _hoisted_7 = {
  key: 0,
  class: "van-hairline--bottom"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label",
  "data-required": ""
}, "被保人姓名", -1))
const _hoisted_9 = {
  key: 1,
  class: "van-hairline--bottom"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label",
  "data-required": ""
}, "被保人身份证号码", -1))
const _hoisted_11 = {
  key: 2,
  class: "van-hairline--bottom"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label",
  "data-required": ""
}, "企业名称", -1))
const _hoisted_13 = {
  key: 3,
  class: "van-hairline--bottom"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label",
  "data-required": ""
}, "企业的统一社会信用代码", -1))
const _hoisted_15 = {
  key: 4,
  class: "van-hairline--bottom"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label",
  "data-required": ""
}, "团体名称", -1))
const _hoisted_17 = {
  key: 5,
  class: "van-hairline--bottom"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label",
  "data-required": ""
}, "工商运营执照号", -1))
const _hoisted_19 = { class: "van-hairline--bottom" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label",
  "data-required": ""
}, "邮箱地址", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "email-notice" }, "注：电子邮箱用于接收安心保电子保单文件，请准确填写。", -1))

import { Form, FieldRule, Field, FormInstance } from 'vant'
import {
  useValidateIDCard,
  useValiedateEmail,
  useValidateSocialCreditCode,
} from '@/compositions/useValidate'
import { withDefaults, reactive, computed, Ref, ref } from 'vue'
import {
  JijiaInsranceCertifivateTextTypeMap,
  getJijiaInsurancePersonalTypeOptions,
} from '@/defination/insurance'
import { commonErrorHandle } from '@/utils/error-handle'
import { requestBatchCorrectInsuredInfo } from '@/apis/insurance'
import {
  ClientJijiaInsuranceListItem,
  RequestBatchCorrectInsuredInfoParams,
} from '@/types/insurance'
import {
  showToastFail,
  showConfirmModal,
  showToastLoading,
  clearToast,
} from '@/utils/tools'
import PopupWrap from '@/components/popup/common-wrap.vue'
import CommonRadioGroup from '@/components/CommmonRadioGroup.vue'
import CommonFooterNextButton from '@/components/CommonFooterNextButton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'insurance-correct-popup',
  props: {
    show: { type: Boolean, default: false },
    guid: { default: '' },
    policy_no: { default: '' },
    phone: { default: '' },
    jijiaItem: null,
    jijiaItems: { default: () => [] }
  },
  emits: ['update:show', 'success'],
  setup(__props: any, { emit: emits }) {

const props = __props as { show: boolean, guid: string, policy_no: string, phone: string, jijiaItem?: ClientJijiaInsuranceListItem, jijiaItems: ClientJijiaInsuranceListItem[] };



const formValue = reactive({
  personnelType: '1',
  name: '',
  certificateNo: '',
  compnayName: '',
  compnayCertificateNo: '',
  groupName: '',
  groupCertificateNo: '',
  email: '',
})
const formVm: Ref<FormInstance | null> = ref(null)
const personalTypeOptions = getJijiaInsurancePersonalTypeOptions(false)
const personalTypeValue = '1' // 个人选项值
const companyTypeValue = '0' // 企业选项值
const groupTypeValue = '2' // 团体选项值 仅定义在前端，后端接口没有这个定义
const isApplicantPersonal = computed(() => {
  // 被保人个人
  return formValue.personnelType === personalTypeValue
})
const isApplicantCompany = computed(() => {
  // 被保人企业
  return formValue.personnelType === companyTypeValue
})
const isApplicantGroup = computed(() => {
  // 被保人团体
  return formValue.personnelType === groupTypeValue
})
const messagesMap = {
  groupName: '请填写团体名称',
  groupCertificateNo: '请填写工商运营执照号',
  compnayName: '请填写企业名称',
  compnayCertificateNo: '请填写企业的统一社会信用代码',
  personnelType: '请选择被保人类型',
  name: '请填写被保人姓名',
  certificateNo: '请填写被保人的身份证号码',
  email: '请填写邮箱地址',
  phone: '请填写被保人电话',
}

const compnayCertificateNoRules = {
  validator: useValidateSocialCreditCode,
  message: '请输入正确的统一社会信用代码',
}
function stringFormatter(value: string) {
  return typeof value === 'string' ? value.trim() : value
}

function getFieldRuleConfig(childKey: unknown): FieldRule[] {
  type p = keyof typeof messagesMap
  if (childKey === 'email') {
    return [
      {
        validator: (value: string) => !value || useValiedateEmail(value),
        trigger: 'onBlur',
        message: '请输入正确的邮箱格式',
      },
    ]
  }
  const result: FieldRule[] = [
    {
      required: true,
      trigger: 'onBlur',
      message: messagesMap[childKey as p],
    },
  ]
  if (childKey === 'certificateNo') {
    result.push({
      validator: useValidateIDCard,
      message: '请输入正确的身份证号码',
    })
  }
  if (childKey === 'compnayCertificateNo') {
    result.push(compnayCertificateNoRules)
  }
  return result
}
async function validateHandle(): Promise<boolean> {
  // 验证参数
  let validateValue = true
  try {
    await formVm.value?.validate() // Form表单验证不通过会
  } catch (error) {
    console.log('error', error)
    validateValue = false
  }
  if (!validateValue) {
    showToastFail('请完善表单信息后再提交')
  }
  return validateValue
}
async function beforeConfirmHandle() {
  const validateValue = await validateHandle()
  if (!validateValue) {
    return
  }
  confirmHandle()
}
function getSubmitParams(): RequestBatchCorrectInsuredInfoParams {
  const items = getCorrectItems()
  const { name, certificate_no } = getCorrectNameAndCertificateNo()
  const params: RequestBatchCorrectInsuredInfoParams = {
    policy_nos: items.map((item) => item.policy_no).filter(Boolean),
    personnel_type: formValue.personnelType,
    name,
    email: formValue.email,
    certificate_no,
  }
  const device_id = items[0]?.eq_sn
  if (device_id) {
    params.device_id = device_id
  }
  return params
}

function getCorrectItems() {
  if (props.jijiaItems?.length) {
    return props.jijiaItems
  }
  return props.jijiaItem ? [props.jijiaItem] : []
}

function getCorrectNameAndCertificateNo() {
  const name = isApplicantPersonal.value
    ? formValue.name
    : isApplicantCompany.value
    ? formValue.compnayName
    : isApplicantGroup.value
    ? formValue.groupName
    : ''
  const certificate_no = isApplicantPersonal.value
    ? formValue.certificateNo
    : isApplicantCompany.value
    ? formValue.compnayCertificateNo
    : isApplicantGroup.value
    ? formValue.groupCertificateNo
    : ''
  return { name, certificate_no }
}

async function confirmHandle() {
  try {
    await showConfirmModal({
      message: '是否确认批改?',
      className: 'repair-dialog',
    })
  } catch (error) {
    return
  }
  showToastLoading()
  try {
    await requestBatchCorrectInsuredInfo(getSubmitParams())
    clearToast()
    updateShwoHandle(false)
    await showConfirmModal({
      title: '保单批改成功',
      message: '',
      confirmButtonText: '知道了',
      className: 'nongfu-dialog-confirm-class nongfu-dialog-confirm-common-class',
      showCancelButton: false,
    })
    emits('success')
  } catch (error) {
    console.log('error', error)
    commonErrorHandle(error)
  }
}
function updateShwoHandle(value: boolean) {
  emits('update:show', value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PopupWrap, {
    title: "批改被保人",
    show: props.show,
    teleport: "body",
    "onUpdate:show": updateShwoHandle
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(Form), {
          class: "main-info",
          ref_key: "formVm",
          ref: formVm
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _hoisted_4,
                  _createVNode(CommonRadioGroup, {
                    style: {"margin-top":"4px"},
                    options: _unref(personalTypeOptions),
                    value: formValue.personnelType,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formValue.personnelType) = $event))
                  }, {
                    radioContent: _withCtx(({ data }) => [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", null, _toDisplayString(data.label), 1),
                        _createElementVNode("div", null, "(" + _toDisplayString(_unref(JijiaInsranceCertifivateTextTypeMap).get(data.value as string)) + ")", 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["options", "value"]),
                  _hoisted_6
                ]),
                (_unref(isApplicantPersonal))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _hoisted_8,
                      _createVNode(_unref(Field), {
                        modelValue: formValue.name,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formValue.name) = $event)),
                        class: "xa-field nongfu-field-wrap",
                        placeholder: messagesMap.name,
                        rules: getFieldRuleConfig('name')
                      }, null, 8, ["modelValue", "placeholder", "rules"])
                    ]))
                  : _createCommentVNode("", true),
                (_unref(isApplicantPersonal))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _hoisted_10,
                      _createVNode(_unref(Field), {
                        modelValue: formValue.certificateNo,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formValue.certificateNo) = $event)),
                        class: "xa-field nongfu-field-wrap",
                        placeholder: messagesMap.certificateNo,
                        rules: getFieldRuleConfig('certificateNo')
                      }, null, 8, ["modelValue", "placeholder", "rules"])
                    ]))
                  : _createCommentVNode("", true),
                (_unref(isApplicantCompany))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _hoisted_12,
                      _createVNode(_unref(Field), {
                        modelValue: formValue.compnayName,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formValue.compnayName) = $event)),
                        class: "xa-field nongfu-field-wrap",
                        placeholder: messagesMap.compnayName,
                        rules: getFieldRuleConfig('compnayName')
                      }, null, 8, ["modelValue", "placeholder", "rules"])
                    ]))
                  : _createCommentVNode("", true),
                (_unref(isApplicantCompany))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _hoisted_14,
                      _createVNode(_unref(Field), {
                        modelValue: formValue.compnayCertificateNo,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formValue.compnayCertificateNo) = $event)),
                        class: "xa-field nongfu-field-wrap",
                        placeholder: messagesMap.compnayCertificateNo,
                        rules: getFieldRuleConfig('compnayCertificateNo')
                      }, null, 8, ["modelValue", "placeholder", "rules"])
                    ]))
                  : _createCommentVNode("", true),
                (_unref(isApplicantGroup))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _hoisted_16,
                      _createVNode(_unref(Field), {
                        modelValue: formValue.groupName,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formValue.groupName) = $event)),
                        class: "xa-field nongfu-field-wrap",
                        placeholder: messagesMap.groupName,
                        rules: getFieldRuleConfig('groupName')
                      }, null, 8, ["modelValue", "placeholder", "rules"])
                    ]))
                  : _createCommentVNode("", true),
                (_unref(isApplicantGroup))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _hoisted_18,
                      _createVNode(_unref(Field), {
                        modelValue: formValue.groupCertificateNo,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formValue.groupCertificateNo) = $event)),
                        class: "xa-field nongfu-field-wrap",
                        placeholder: messagesMap.groupCertificateNo,
                        rules: getFieldRuleConfig('groupCertificateNo')
                      }, null, 8, ["modelValue", "placeholder", "rules"])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createVNode(_unref(Field), {
                    modelValue: formValue.email,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formValue.email) = $event)),
                    class: "xa-field nongfu-field-wrap",
                    formatter: stringFormatter,
                    placeholder: messagesMap.email,
                    rules: getFieldRuleConfig('email')
                  }, null, 8, ["modelValue", "placeholder", "rules"])
                ])
              ]),
              _hoisted_21
            ])
          ]),
          _: 1
        }, 512),
        _createVNode(CommonFooterNextButton, {
          title: "保存",
          class: "confirm-button",
          onClick: beforeConfirmHandle
        })
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})